import { useMutation } from 'react-query'
import { api } from '../../../api'

const deleteProject = async (id: number) => {
  const response = await api.delete(`/projects/${id}`)
  return response.data
}

export const useProjectDeleteMutation = () => {
  return useMutation({
    mutationFn (id: number) {
      return deleteProject(id)
    }
  })
}
